import React, { useEffect, useState } from 'react'
import { IOrder } from '../../interfaces/order';
import { useParams } from 'react-router-dom';
import { callApi } from '../../api/callApi';
import { API_ENDPOINT, API_URL, API_URL_2 } from '../../api/constant';
import Layout from '../../components/Layout/Layout';
import StatusDropDown from '../../components/common/OrderStatusDropdown';
import { ISettings } from '../../interfaces/settings';
import { formatDateTime, getPaymentMethodMessage, showToastNotification, toFixedThree } from '../../utility/helper';
import useOrderApi from '../../hooks/useDownloadInvoice';
import Button from '../../components/UI/Buttons/Button';
import Modal from '../../components/UI/Modal/Modal';
import AssignDriverModal from './AssignDriverModal';
import moment from '../../utility/moment-timezone';
import useConfirmationModal from '../../hooks/useConfirmationModal';
import ConfirmationModal from '../../components/UI/Modal/ConfirmationModal';
import { IMeateryBox } from '../../interfaces/meateryBox';
import { IProduct } from '../../interfaces/product';

const OrderDetail: React.FC = () => {
    const { showModal, modalProps, confirmAction } = useConfirmationModal();
    const { id } = useParams()
    const [loading, setLoading] = useState<boolean>(false);
    const [orderDetail, setOrderDetail] = useState<IOrder>();
    const [settings, setSettings] = useState<ISettings | null>(null);
    const [selectedItems, setSelectedItems] = useState<string[]>([]);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [driverModal, setDriverModal] = useState(false)
    const { downloadInvoice } = useOrderApi();
    const [rejectOrder, setRejectOrder] = useState({
        show: false,
        rejectReason: '',
        error: ''
    });

    const [delayReasonModal, setDelayReasonModal] = useState({
        show: false,
        reason: '',
        error: ''
    });

    useEffect(() => {
        getOrderDetails();
        fetchSettings()
    }, [id])

    const getOrderDetails = async () => {
        try {
            setLoading(true);
            const response = await callApi(API_URL_2 + API_ENDPOINT.order + `orders/${id}`, { method: 'GET' });
            setOrderDetail(response);
        } catch (error: any) {
            console.error('Failed to fetch products:', error.message);
        } finally {
            setLoading(false);
        }
    }

    const fetchSettings = async () => {
        try {
            const response = await callApi(API_URL + API_ENDPOINT.auth + 'settings', { method: 'GET' });
            if (response && response.length > 0) {
                let setting = response[0]
                setSettings(setting)
            }

        } catch (error: any) {
            console.error('Failed to fetch settings:', error.message);
        }
    };

    const handleCheckboxChange = (itemId: string) => {
        setErrorMessage('');
        setSelectedItems((prevSelected) =>
            prevSelected.includes(itemId)
                ? prevSelected.filter((id) => id !== itemId)
                : [...prevSelected, itemId]
        );
    };

    const onAcceptRefund = () => {
        if (selectedItems.length === 0) {
            return setErrorMessage('Please select at least one item.');
        }

        setErrorMessage('');

        const selectedItemsData = orderItems.filter(item => selectedItems.includes(item.itemId));
        const rawTotal = selectedItemsData.reduce((sum, item) => sum + item.price, 0);

        // For cart-level discount, calculate proportion for selected items
        const totalOrderValue = orderItems.reduce((sum, item) => sum + item.price, 0);
        const discountProportion = rawTotal / totalOrderValue;
        const allocatedDiscount = discountedValue * discountProportion;

        let finalTotal = rawTotal - allocatedDiscount;

        // Add delivery fees only if ALL items are selected
        if (orderItems.length === selectedItems.length) {
            finalTotal += deliveryFees;
        }

        finalTotal = parseFloat(finalTotal.toFixed(3));

        console.log("Refund Total:", finalTotal);
        console.log("Allocated Discount:", orderItems);
        updateRefundRequest('REFUNDED', { refundAmount: finalTotal.toString() });
    }

    const onRejectRefund = () => {
        updateRefundRequest('REFUNDED REJECTED', { rejectReason: rejectOrder.rejectReason })
    }
    const updateRefundRequest = async (status: string, postData: any) => {
        try {
            const response = await callApi(API_URL_2 + API_ENDPOINT.order + `orders/update-status`, {
                method: 'PUT',
                data: { id: id, status, ...postData }
            });
            getOrderDetails()
            console.log("Response", response);
            // setOrderDetail(response)
            showToastNotification('success', 'Order refund request successfully updated');
            setRejectOrder({ ...rejectOrder, show: false, rejectReason: '', error: '' })

        } catch (error: any) {
            showToastNotification('danger', error?.message ?? 'Failed to update order refund request');
            console.error('Failed to update status:' + error?.message);
        }
    }

    const handleDelayReasonSubmit = async (reason: string) => {
        try {
            const response = await callApi(API_URL_2 + API_ENDPOINT.order + `orders/delay-reason/${id}`, {
                method: 'PUT',
                data: { reason: reason }
            });
            getOrderDetails()
            console.log("Response", response);
            // setOrderDetail(response)
            showToastNotification('success', 'Order refund request successfully updated');
            setDelayReasonModal({ ...rejectOrder, show: false, reason: '', error: '' })

        } catch (error: any) {
            showToastNotification('danger', error?.message ?? 'Failed to update order refund request');
            console.error('Failed to update status:' + error?.message);
        }
    };

    const revertCancellation = async () => {
        confirmAction({
            title: 'Confirm Revert',
            message: 'Are you sure you want to revert this order’s cancellation and restore it to active status?',
            onConfirm: () => handleRevertCancellation(),
        });
    }
    const handleRevertCancellation = async () => {
        try {
            await callApi(API_URL_2 + API_ENDPOINT.order + `orders/${id}/revert-status`, {
                method: 'PATCH'
            })
            getOrderDetails();
            showToastNotification('success', 'Order cancellation reverted successfully');
        } catch (error: any) {
            showToastNotification('danger', error?.message ?? 'Failed to revert order cancellation');
            console.error('Failed to revert order cancellation:' + error?.message);
        }
    }


    if (loading) return <Layout>Loading...</Layout>;

    if (!orderDetail) return <Layout>No Data Found</Layout>;
    const {
        personalInfo,
        // driverDetail,
        refundInfo,
        address,
        paymentMethod,
        orderItems,
        deliveryStatus,
        status,
        orderId,
        gift,
        total,
        // delayReason,
        grandTotal,
        // taxRate,
        // withTaxAmount,
        paidByWallet,
        deliveryFees,
        deliveryTime,
        previousStatus,
        createdAt,
        // driverRating,
        specialInstruction,
        discountedValue
    } = orderDetail;

    return (
        <Layout>
            <div className="container mt-2">
                <div className='d-flex justify-content-between align-items-center gap-3 flex-wrap mb-3'>
                    <h1 className="mb-4 app-page-title">Order Details</h1>
                    <div className='d-flex gap-3 align-items-center'>
                        {/* {status === 'ACCEPTED' && !driverDetail && <button onClick={() => setDriverModal(true)} className='btn app-btn-primary d-flex align-items-center gap-1'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.13261 0 6.25979 0.0526785 6.35355 0.146447C6.44732 0.240215 6.5 0.367392 6.5 0.5V5.5H11.5C11.6326 5.5 11.7598 5.55268 11.8536 5.64645C11.9473 5.74021 12 5.86739 12 6C12 6.13261 11.9473 6.25979 11.8536 6.35355C11.7598 6.44732 11.6326 6.5 11.5 6.5H6.5V11.5C6.5 11.6326 6.44732 11.7598 6.35355 11.8536C6.25979 11.9473 6.13261 12 6 12C5.86739 12 5.74021 11.9473 5.64645 11.8536C5.55268 11.7598 5.5 11.6326 5.5 11.5V6.5H0.5C0.367392 6.5 0.240215 6.44732 0.146447 6.35355C0.0526785 6.25979 0 6.13261 0 6C0 5.86739 0.0526785 5.74021 0.146447 5.64645C0.240215 5.55268 0.367392 5.5 0.5 5.5H5.5V0.5C5.5 0.367392 5.55268 0.240215 5.64645 0.146447C5.74021 0.0526785 5.86739 0 6 0Z" fill="white" />
                        </svg> Assign Driver</button>} */}
                        {status === 'CANCELLED' && <button className='btn app-btn-primary d-flex align-items-center gap-1' onClick={() => revertCancellation()} >
                            Revert Cancellation
                        </button>}
                        <div className="" style={{ cursor: 'pointer' }} onClick={() => downloadInvoice(orderDetail.id || '')} >
                            <span className="badge text-bg-warning d-flex align-items-center gap-2 ">
                                View Order Confirmation
                                <i className='bi bi-eye' />
                            </span>
                        </div>
                        <h6 className='mb-0'>Update Status</h6>
                        <StatusDropDown
                            CurrentStatus={status}
                            orderId={orderDetail.id}
                            orderStatus={settings?.orderStatus || []}
                            previousStatus={orderDetail.previousStatus}
                            // driverDetail={orderDetail.driverDetail}
                            updateStatus={() => getOrderDetails()} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-8 col-12">
                        <div className='app-card app-card-orders-table shadow-sm mb-4 p-4'>
                            <div className="app-card-body">
                                <div className="">
                                    <h5 className='fw-bold'>Order Information</h5>
                                </div>
                                <div>

                                    <div className='row mb-1'>
                                        <strong className='col-md-6 col-12'>Order ID:</strong>
                                        <p className='mb-0 col-md-6 col-12'>{orderId}</p>
                                    </div>
                                    <div className='row mb-1'>
                                        <strong className='col-md-6 col-12'>Status:</strong>
                                        <p className='mb-0 col-md-6 col-12'> {status}</p>
                                    </div>
                                    <div className='row mb-1'>
                                        <strong className='col-md-6 col-12'>Delivery Time:</strong>
                                        <p className='mb-0 col-md-6 col-12'> {formatDateTime(deliveryTime || '')}</p>
                                    </div>
                                    <div className='row mb-1'>
                                        <strong className='col-md-6 col-12'>Delivery Status:</strong>
                                        <p className='mb-0 col-md-6 col-12'> {deliveryStatus || '-'}</p>
                                    </div>
                                    <div className='row mb-1'>
                                        <strong className='col-md-6 col-12'>Total:</strong>
                                        <p className='mb-0 col-md-6 col-12'> BHD {toFixedThree(total)}</p>
                                    </div>
                                    <div className='row mb-1'>
                                        <strong className='col-md-6 col-12'>Discount:</strong>
                                        <p className='mb-0 col-md-6 col-12 text-success'> BHD {toFixedThree(discountedValue)}</p>
                                    </div>

                                    <div className='row mb-1'>
                                        <strong className='col-md-6 col-12'>Delivery Fees:</strong>
                                        <p className='mb-0 col-md-6 col-12'> BHD {toFixedThree(deliveryFees)}</p>
                                    </div>
                                    <div className='row mb-1'>
                                        <strong className='col-md-6 col-12'>Pay By Wallet:</strong>
                                        <p className='mb-0 col-md-6 col-12 text-success'> BHD {toFixedThree(paidByWallet ?? 0)}</p>
                                    </div>
                                    {/* <div className='row mb-1'>
                                        <strong className='col-md-6 col-12'>VAT ({taxRate}%):</strong>
                                        <p className='mb-0 col-md-6 col-12'> BHD {toFixedThree(withTaxAmount - total)}</p>
                                    </div> */}
                                    <div className='row mb-1'>
                                        <strong className='col-md-6 col-12'>Grand Total:</strong>
                                        <p className='mb-0 col-md-6 col-12'> BHD {toFixedThree(grandTotal)}</p>
                                    </div>
                                    <div className='row mb-1'>
                                        <strong className='col-md-6 col-12'>Order Time:</strong>
                                        <p className='mb-0 col-md-6 col-12'> {moment(createdAt).format("DD MMM,YYYY hh:mm a")}</p>
                                    </div>
                                    <div className='row mb-1'>
                                        <strong className='col-md-6 col-12'>Payment Type:</strong>
                                        <p className='mb-0 col-md-6 col-12'>{getPaymentMethodMessage(paymentMethod.type)} </p>
                                    </div>
                                    <div className='row mb-1'>
                                        <strong className='col-md-6 col-12'>Transection ID:</strong>
                                        <p className='mb-0 col-md-6 col-12'>{orderDetail.chargeId} </p>
                                    </div>
                                    {previousStatus.find(s => s.status === 'DELIVERED') && <div className='mb-1 row'>
                                        <strong className='col-md-6 col-12'>Order Delivery Time:</strong>
                                        <p className='mb-0 col-md-6 col-12'> {moment(previousStatus.find(s => s.status === 'DELIVERED')?.dateTime).format("DD MMM,YYYY hh:mm a")}</p>
                                    </div>}
                                    {specialInstruction && <div className='row mb-1'>
                                        <strong className='col-md-6 col-12'>Special Instructions:</strong>
                                        <p className='mb-0 col-md-6 col-12'>{specialInstruction} </p>
                                    </div>}
                                    {/* {deliveryStatus === 'DELAYED' && !delayReason && (
                                        <div className="row mt-3">
                                            <div className="col-12 text-center">
                                                <button
                                                    className="btn btn-warning"
                                                    onClick={() => setDelayReasonModal(prev => ({ ...prev, show: true }))}
                                                >
                                                    Add Delivery Delay Reason
                                                </button>
                                            </div>
                                        </div>
                                    )} */}
                                </div>
                            </div>
                        </div>
                        {refundInfo &&
                            <div className="app-card app-card-orders-table shadow-sm mb-4 p-4">
                                <div className="app-card-body">
                                    <div className='d-flex justify-content-between align-items-start'>
                                        <h5 className="fw-bold mb-3">Order Refund Request</h5>
                                    </div>
                                    {/* Refund Message */}
                                    {orderDetail.status === 'REFUNDED' &&
                                        <div className='mb-3 d-flex justify-content-between gap-3 flex-wrap align-items-start'>
                                            <div className="mb-3">
                                                <strong>Refund Info:</strong>
                                                <p className="mb-0">{`An amount of ${parseFloat(refundInfo?.refundAmount ?? '').toFixed(3)} has been transferred to the user's Meatery wallet.`}</p>
                                            </div>
                                            <span className="badge text-bg-success d-flex align-items-center gap-2 text-white">
                                                Refund Request Accepted
                                            </span>
                                        </div>
                                    }


                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="mb-3">
                                                <strong>Refund Reason:</strong>
                                                <p className="mb-0">{refundInfo.message}</p>
                                            </div>
                                        </div>
                                        <div className='col-sm-12'>
                                            {refundInfo.rejectReason && (
                                                <div className="mb-3">
                                                    <strong>Reject Reason:</strong>
                                                    <p className="mb-0">{refundInfo.rejectReason} </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* List of Items */}
                                    <div className="mb-3">
                                        <strong>Items:</strong>
                                        <ul className="list-group">
                                            {refundInfo.items.map((item) => (
                                                <li key={item.id} className="list-group-item d-flex align-items-center">
                                                    <label htmlFor={item.id}>
                                                        {orderDetail.status === 'CLIENT UPDATED ORDER' &&
                                                            <input
                                                                id={item.id}
                                                                type="checkbox"
                                                                className="form-check-input me-2"
                                                                checked={selectedItems.includes(item.id)}
                                                                onChange={() => handleCheckboxChange(item.id)}
                                                            />
                                                        }
                                                        {item.name}

                                                    </label>
                                                </li>
                                            ))}
                                        </ul>
                                        {errorMessage && <div className="text-danger mt-2">{errorMessage}</div>}
                                    </div>
                                    {/* Images */}
                                    <div className="mb-3">
                                        <div className='mb-1'>
                                            <strong>Images:</strong>
                                        </div>
                                        <div className="d-flex flex-wrap">
                                            {refundInfo.images.map((src, index) => (
                                                <img
                                                    key={index}
                                                    src={src}
                                                    alt={`Refund image ${index + 1}`}
                                                    className="img-thumbnail me-2 mb-2"
                                                    style={{ width: '100px', height: 'auto' }}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                    {/* Optional Reject Reason */}

                                    {orderDetail.status === 'CLIENT UPDATED ORDER' &&
                                        <div className="mt-3 pt-3 border-top d-flex justify-content-end">
                                            <Button loading={loading} className="app-btn-primary mx-3" type="button" text="Accept" onClick={onAcceptRefund} />
                                            <Button loading={loading} className="btn-danger" type="button" text="Reject" onClick={() => setRejectOrder({ ...rejectOrder, show: true })} />
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                        <div className='app-card app-card-orders-table shadow-sm mb-4 p-4'>
                            <div className='app-card-body'>
                                <div className="mb-4">
                                    <h5 className="fw-bold">Delivery Address</h5>
                                    <div>
                                        {/* Address Type - Always show */}
                                        <div className='mb-1 row'>
                                            <strong className='col-md-6 col-12'>Address Type:</strong>
                                            <p className='mb-0 col-md-6 col-12'>
                                                {address.addressType}
                                            </p>
                                        </div>

                                        {/* Building Name - Show for all types if exists */}


                                        <>
                                            {address.aptNumber && (
                                                <div className='mb-1 row'>
                                                    <strong className='col-md-6 col-12'>House / Villa / Building No.:</strong>
                                                    <p className='mb-0 col-md-6 col-12'>
                                                        {address.aptNumber}
                                                    </p>
                                                </div>
                                            )}
                                            {address.buildingName && (
                                                <div className='mb-1 row'>
                                                    <strong className='col-md-6 col-12'>Apartment / Building Name:</strong>
                                                    <p className='mb-0 col-md-6 col-12'>
                                                        {address.buildingName}
                                                    </p>
                                                </div>
                                            )}
                                            {/* {address.floor && (
                                                <div className='mb-1 row'>
                                                    <strong className='col-md-6 col-12'>Floor:</strong>
                                                    <p className='mb-0 col-md-6 col-12'>
                                                        {address.floor}
                                                    </p>
                                                </div>
                                            )} */}
                                        </>


                                        {/* Common address fields for all types */}
                                        {address.street && (
                                            <div className='mb-1 row'>
                                                <strong className='col-md-6 col-12'>Road No.:</strong>
                                                <p className='mb-0 col-md-6 col-12'>
                                                    {address.street}
                                                </p>
                                            </div>
                                        )}

                                        {address.block && (
                                            <div className='mb-1 row'>
                                                <strong className='col-md-6 col-12'>Block:</strong>
                                                <p className='mb-0 col-md-6 col-12'>
                                                    {address.block}
                                                </p>
                                            </div>
                                        )}

                                        {address.area && (
                                            <div className='mb-1 row'>
                                                <strong className='col-md-6 col-12'>Area:</strong>
                                                <p className='mb-0 col-md-6 col-12'>
                                                    {address.area}
                                                </p>
                                            </div>
                                        )}

                                        {/* Company Name - Show only for Office if exists */}
                                        {address.addressType === 'Office' && address.companyName && (
                                            <div className='mb-1 row'>
                                                <strong className='col-md-6 col-12'>Company Name:</strong>
                                                <p className='mb-0 col-md-6 col-12'>
                                                    {address.companyName}
                                                </p>
                                            </div>
                                        )}

                                        {/* Additional Direction - Show for all types if exists */}
                                        {address.additionalDirection && (
                                            <div className='mb-1 row'>
                                                <strong className='col-md-6 col-12'>Additional Direction:</strong>
                                                <p className='mb-0 col-md-6 col-12'>
                                                    {address.additionalDirection}
                                                </p>
                                            </div>
                                        )}

                                        {/* Phone - Show for all types if exists */}
                                        {address.phone && (
                                            <div className='mb-1 row'>
                                                <strong className='col-md-6 col-12'>Phone:</strong>
                                                <p className='mb-0 col-md-6 col-12'>
                                                    {address.phone}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className='app-card app-card-orders-table shadow-sm mb-4 p-4'>
                            <h5 className="fw-bold">Driver Information</h5>
                            <div className="">
                                <div className='mb-1 row'>
                                    <strong className='col-md-6 col-12'>Name:</strong>
                                    <p className='mb-0 col-md-6 col-12'> {driverDetail?.fullName || 'N/A'}</p>
                                </div>
                                <div className='mb-1 row'>
                                    <strong className='col-md-6 col-12'>Mobile:</strong>
                                    <p className='mb-0 col-md-6 col-12'>{driverDetail?.phone || 'N/A'}</p>
                                </div>
                                <div className='mb-1 row'>
                                    <strong className='col-md-6 col-12'>Email:</strong>
                                    <p className='mb-0 col-md-6 col-12'> {driverDetail?.email || 'N/A'}</p>
                                </div>
                                <div className='mb-1 row'>
                                    <strong className='col-md-6 col-12'>Order Delivery Time:</strong>
                                    <p className='mb-0 col-md-6 col-12'> {getTimeDifference("PICKED UP", "DELIVERED", previousStatus)}</p>
                                </div>

                                {deliveryStatus === 'DELAYED' && <div className='mb-1 row'>
                                    <strong className='col-md-6 col-12'>Order Delay Reason:</strong>
                                    <p className='mb-0 col-md-6 col-12'> {delayReason || 'N/A'}</p>
                                </div>}
                                {driverRating && <div className='mb-1 row'>
                                    <strong className='col-md-6 col-12'>Delivery Rating:</strong>
                                    <p className='mb-0 col-md-6 col-12'>
                                        <p
                                            className="star-rating"
                                            style={{ color: '#ffc107', fontSize: '1.2rem' }}
                                        >
                                            {'★'.repeat(Math.round(driverRating.rating)) +
                                                '☆'.repeat(5 - Math.round(driverRating.rating))}
                                        </p>
                                    </p>
                                </div>}
                                {driverRating && <div className='mb-1 row'>
                                    <strong className='col-md-6 col-12'>Delivery Review:</strong>
                                    <p className='mb-0 col-md-6 col-12'> {driverRating.review}</p>
                                </div>}
                            </div>
                        </div> */}
                    </div>
                    <div className="col-lg-4 col-12">
                        <div className='app-card app-card-orders-table shadow-sm mb-4 p-4'>
                            <h5 className="fw-bold">Customer Information</h5>
                            <div className="">
                                <div className='mb-1'>
                                    <strong>Name:</strong>
                                    <p className='mb-0'> {personalInfo?.firstName} {personalInfo?.lastName}</p>
                                </div>
                                <div className='mb-1'>
                                    <strong>Email:</strong>
                                    <p className='mb-0'> {personalInfo?.email}</p>
                                </div>

                            </div>
                        </div>
                        {gift && <div className='app-card app-card-orders-table shadow-sm mb-4 p-4'>
                            <h5 className="fw-bold">Gift Hamper Info</h5>
                            <div className="">
                                <div className='mb-1'>
                                    <p className='mb-0'> {gift.name}</p>
                                </div>
                                <div className='mb-1'>
                                    <p className='mb-0'>    <img

                                        src={gift.image}
                                        alt={gift.image ?? ''}
                                        className="img-thumbnail"
                                        style={{ width: "100%", height: "100%", maxHeight: '250px', maxWidth: '100%' }}
                                    /></p>
                                </div>

                            </div>
                        </div>}

                    </div>
                    <div className='col-lg-12 col-12'>
                        <div className='app-card app-card-orders-table shadow-sm mb-4 p-4'>
                            <h5 className="fw-bold mb-4">Order Items ({orderItems.length})</h5>

                            <div className="table-responsive">
                                <table className="table table-hover mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col" style={{ width: '50px' }}>#</th>
                                            <th scope="col">Product</th>
                                            <th scope="col">Details</th>
                                            <th scope="col" className="text-center" style={{ width: '100px' }}>Qty</th>
                                            <th scope="col" className="text-end" style={{ width: '120px' }}>Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderItems.map((item, index) => (
                                            <>
                                                {/* Main Product Row */}
                                                <tr key={item.id} className={item.isBundle ? 'table-primary' : ''}>
                                                    <td className="align-middle">
                                                        <span className="">{index + 1}</span>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <div className="flex-shrink-0 me-3">
                                                                <img
                                                                    src={item.itemDetail.product?.images?.[0]}
                                                                    alt={item.itemDetail.product?.title || 'Product Image'}
                                                                    className="img-thumbnail"
                                                                    style={{ width: "60px", height: "60px", objectFit: "cover" }}
                                                                />
                                                            </div>
                                                            <div className="flex-grow-1">
                                                                <div className="fw-bold mb-1">{item.itemDetail.product?.title}</div>
                                                                {item.isBundle && (
                                                                    <span className="badge bg-primary bg-opacity-10 text-primary">
                                                                        Meatery Box
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {/* Regular Product Details */}
                                                        {!item.isBundle ? (
                                                            <div className="product-details">
                                                                <div className="d-flex flex-wrap gap-1 mb-1">
                                                                    {(item.itemDetail.product as IProduct)?.typeOfMeat?.map((meatType, idx) => (
                                                                        <span key={idx} className="badge bg-secondary bg-opacity-10 text-primary">
                                                                            {meatType}
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                                <div className="" style={{ fontSize: '0.85rem' }}>
                                                                    <div className="mb-1">
                                                                        <strong>Weight:</strong> {item.itemDetail.pieceWeight || 'N/A'}
                                                                    </div>
                                                                    <div className="mb-1">
                                                                        <strong>State:</strong> {(item.itemDetail.product as IProduct)?.state || 'N/A'}
                                                                    </div>
                                                                    <div className="mb-1">
                                                                        <strong>Origin:</strong> {(item.itemDetail.product as IProduct)?.origin || 'N/A'}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="" style={{ fontSize: '0.9rem' }}>
                                                                <div className="mb-1">
                                                                    Bundle containing {(item.itemDetail.product as IMeateryBox)?.items?.length || 0} items
                                                                </div>
                                                                {(item.itemDetail.product as IMeateryBox)?.additionalItems && (
                                                                    <div className="" style={{ fontSize: '0.85rem' }}>
                                                                        <strong>Additional Items:</strong> {(item.itemDetail.product as IMeateryBox)?.additionalItems}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td className="align-middle text-center">
                                                        <span className="fw-medium">{item.quantity}</span>
                                                    </td>
                                                    <td className="align-middle text-end">
                                                        <div className="fw-bold">BHD {toFixedThree(item.price)}</div>
                                                        <div className=" small">
                                                            Total: BHD {toFixedThree(item.price * item.quantity)}
                                                        </div>
                                                    </td>
                                                </tr>

                                                {/* Bundle Contents Rows */}
                                                {item.isBundle && (item.itemDetail.product as IMeateryBox)?.items?.map((bundleItem) => (
                                                    <tr key={bundleItem.id} className="table-light">
                                                        <td></td>
                                                        <td>
                                                            <div className="d-flex align-items-center ms-4">
                                                                <div className="flex-shrink-0 me-2">
                                                                    <img
                                                                        src={bundleItem.product.images?.[0]}
                                                                        alt={bundleItem.product.title}
                                                                        className="img-thumbnail"
                                                                        style={{ width: "40px", height: "40px", objectFit: "cover" }}
                                                                    />
                                                                </div>
                                                                <div className="flex-grow-1">
                                                                    <div className="fw-medium" style={{ fontSize: '0.9rem' }}>
                                                                        {bundleItem.product.title}
                                                                    </div>
                                                                    <div className="" style={{ fontSize: '0.8rem' }}>
                                                                        Included in box
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="bundle-item-details" style={{ fontSize: '0.85rem' }}>
                                                                <div className="">
                                                                    <strong>Qty in box:</strong> {bundleItem.quantity}
                                                                </div>
                                                                {bundleItem.product.productInfo?.[0]?.pieceWeight && (
                                                                    <div className="">
                                                                        <strong>Weight:</strong> {bundleItem.product.productInfo[0].pieceWeight}
                                                                    </div>
                                                                )}
                                                                {bundleItem.product.typeOfMeat?.length > 0 && (
                                                                    <div className="d-flex flex-wrap gap-1 mt-1">
                                                                        {bundleItem.product.typeOfMeat.map((meatType, idx) => (
                                                                            <span key={idx} className="badge bg-secondary bg-opacity-10 text-primary">
                                                                                {meatType}
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className="text-center">
                                                            <span className=" small">×{bundleItem.quantity}</span>
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                ))}

                                                {/* Separator Row */}
                                                {index < orderItems.length - 1 && (
                                                    <tr>
                                                        <td colSpan={5} className="p-0">
                                                            <div className="border-bottom my-2"></div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Modal
                show={rejectOrder.show}
                onClose={() => setRejectOrder({ show: false, rejectReason: '', error: '' })}
                title="Please Enter Reject Reason"
            >
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        if (!rejectOrder.rejectReason.trim()) {
                            setRejectOrder({ ...rejectOrder, error: 'Reject reason is required.' });
                            return;
                        }
                        onRejectRefund()
                    }}
                >
                    <div className="mb-3">
                        <label htmlFor="rejectReason" className="form-label">
                            Reject Reason
                        </label>
                        <textarea
                            id="rejectReason"
                            className="form-control"
                            rows={3}
                            placeholder="Enter your reason here"
                            value={rejectOrder.rejectReason}
                            onChange={(e) =>
                                setRejectOrder({ ...rejectOrder, rejectReason: e.target.value, error: '' })
                            }
                        />
                        {rejectOrder.error && (
                            <div className="text-danger mt-1">{rejectOrder.error}</div>
                        )}
                    </div>
                    <button type="submit" className="btn btn-primary">
                        Submit
                    </button>
                </form>
            </Modal>
            <Modal
                show={delayReasonModal.show}
                onClose={() => setDelayReasonModal({ show: false, reason: '', error: '' })}
                title="Please Enter Delay Reason"
            >
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        if (!delayReasonModal.reason.trim()) {
                            setDelayReasonModal(prev => ({ ...prev, error: 'Delay reason is required.' }));
                            return;
                        }
                        // Handle delay reason submission here
                        handleDelayReasonSubmit(delayReasonModal.reason);
                    }}
                >
                    <div className="mb-3">
                        <label htmlFor="delayReason" className="form-label">
                            Add Delivery Delay Details
                        </label>
                        <textarea
                            id="delayReason"
                            className="form-control"
                            rows={3}
                            placeholder="Enter the reason for the delay "
                            value={delayReasonModal.reason}
                            onChange={(e) =>
                                setDelayReasonModal(prev => ({
                                    ...prev,
                                    reason: e.target.value,
                                    error: ''
                                }))
                            }
                        />
                        {delayReasonModal.error && (
                            <div className="text-danger mt-1">{delayReasonModal.error}</div>
                        )}
                    </div>
                    <button type="submit" className="btn btn-primary">
                        Submit Reason
                    </button>
                </form>
            </Modal>
            <AssignDriverModal modal={driverModal} close={() => {
                setDriverModal(false);
                getOrderDetails()
            }} selectedOrders={[orderDetail.id]} />
            <ConfirmationModal {...modalProps} show={showModal} />
        </Layout>
    )
}

export default OrderDetail